
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import { defineComponent } from "vue";

import MasterFitur from "@/components/1crm/fitur/master-fitur/index.vue";

export default defineComponent({
  name: "kt-widget-11",
  components: {
    MasterFitur,
  },
  props: {
    widgetClasses: String,
  },
  beforeMount() {
    store.dispatch(Actions.VERIFY_AUTH_USER);
    setCurrentPageBreadcrumbs("Master Fitur", ["Management Fitur"]);
  },
});
